const style = theme => ({
  dialogPaper: {
    overflow: 'visible',
    position: 'relative',
    padding: '40px',
  },
  cardMain: {
    boxShadow: 'none',
    margin: 0,
  },
  cardBody: {
    padding: 0,
    paddingTop: '40px',
  },
  boxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
  boxHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  titleHeader: {
    fontWeight: 500,
    fontSize: 18,
  },
  descriptionHeader: {
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
  highlightHeader: {
    fontWeight: 700,
  },
  instructionsHeader: {
    fontWeight: 500,
    fontSize: 16,
  },
  iconButtonHeader: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: '10px',
    width: '46px',
    height: '46px',
    cursor: 'default',
    outline: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  iconHeader: {
    color: theme.palette.common.white,
  },
  actionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '50px',
    width: '100%',
    paddingTop: '40px',
  },
  actionsButtonsDialog: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  selectWrapper: {
    maxWidth: '200px',
  },
  dialogAlertContentCustom: {
    padding: '0 24px 16px',
  },
  dialogAlertActionsCustom: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '0 20px 20px 20px',
  },
  dialogAlertButtonCustom: {
    padding: '8px 16px',
    outline: 'none',
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.15)',
    borderRadius: '20px',
    lineHeight: 1,

  },
  saveButton: {
    color: 'white',
  },
  alertContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  alertText: {
    fontSize: 14,
  },
  alertHighlight: {
    fontSize: 14,
    fontWeight: 500,
  },
});

export default style;
